import PropTypes from "prop-types";
import useCountryAcceptance from "../api/useCountryAcceptance";
import useCityGuideData from "../api/useCityGuideData";
import Intro from "./Intro";
import Map from "./Map";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Box, CircularProgress, useTheme } from "@mui/material/";
import transformCitiesData from "./Map/transforms";
import TechDiff from "./TechDiff";

const Content = () => {
  const theme = useTheme();

  const {
    status: countryStatus,
    data: countryData,
    error: countryError,
  } = useCountryAcceptance();
  const {
    status: citiesStatus,
    data: citiesData,
    error: citiesError,
  } = useCityGuideData("cities", {
    pagesize: 1000,
  });

  if (countryError || citiesError) return <TechDiff />;
  if (countryStatus === "loading" || citiesStatus === "loading") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100vw"
        bgcolor="common.white"
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }
  if (countryData && citiesData) {
    const transformedCities = transformCitiesData(
      citiesData?.result,
      theme.lang
    );

    return (
      <Router basename={`/unionpay/`}>
        <Switch>
          <Route
            path="/guides/newyork"
            render={() => {
              return (
                <Map
                  acceptanceData={countryData?.result}
                  cities={transformedCities}
                  defaultCityView="New York"
                />
              );
            }}
          />
          <Route
            path="/guides/losangeles"
            render={() => {
              return (
                <Map
                  acceptanceData={countryData?.result}
                  cities={transformedCities}
                  defaultCityView="Los Angeles"
                />
              );
            }}
          />

          <Route exact path="/techdiff">
            <TechDiff />
          </Route>

          <Route path="/*">
            <Intro />
          </Route>
        </Switch>
      </Router>
    );
  }
};

Content.propTypes = {
  id: PropTypes.object,
};

export default Content;
